import React, { useCallback, useEffect, useRef, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { IoPersonOutline, IoSearchSharp } from "react-icons/io5";
import { FaPlus } from "react-icons/fa6";
import { PiChatTeardropText, PiSignOut } from "react-icons/pi";
import { IoVideocamOutline } from "react-icons/io5";
import DoneIcon from "@mui/icons-material/Done";

import { TbGridDots } from "react-icons/tb";
import { IoSettingsOutline } from "react-icons/io5";
import {
  IoIosArrowBack,
  IoIosArrowForward,
  IoIosSearch,
  IoMdArrowBack,
} from "react-icons/io";
import { BsPlusLg } from "react-icons/bs";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { CgMenuGridR } from "react-icons/cg";
import {
  AppBar,
  Box,
  Stack,
  Drawer as MuiDrawer,
  IconButton,
  List,
  ListItemText,
  Divider,
  Toolbar,
  Typography,
  ListItemButton,
  Menu,
  MenuItem,
  useTheme as useMuiTheme,
  styled,
  useMediaQuery,
  ListItem,
  ListItemIcon,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { VscMenu } from "react-icons/vsc";
import EditIcon from "@mui/icons-material/Edit";
import Notification from "../components/AnimatedBell";
import Clikklebrand from "../assets/esignlogo.png";
import { useTheme } from "../styles/theme";
import { useMenu } from "../hooks/useMenu";
import SearchBar from "./SearchBar";
import { useMessage } from "./Header";
import { clearCookie, getCookie, setCookie } from "../utilities/cookies";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import ActionIcon from "./ActionIcon";
import ProfileMenuModal from "./ProfileMenuModal";
import AdminSettingsModal from "./AdminSettingsModal";
import { FiSettings } from "react-icons/fi";
import TopNavigation from "./TopNavigation";
import GradientButton from "./GradientButton";
import { Save, LightMode, DarkMode, AdminPanelSettings } from "@mui/icons-material";
import { userMenuItems } from "../data/sidebarLinks";



const clikkleApps = [
  {
    name: "Worksuite",
    url: "https://worksuite.clikkle.com",
    logo: "https://cdn.clikkle.com/images/worksuite/2025/clikkle%20worksuite.png",
  },
  {
    name: "Campaigns",
    url: "https://campaigns.clikkle.com/",
    logo: "https://cdn.clikkle.com/images/campaigns/logo/2025/clikkle%20campaigns.png",
  },
  {
    name: "Chat",
    url: "https://chat.clikkle.com/",
    logo: "https://cdn.clikkle.com/images/chat/logo/2025/clikkle%20chat.png",
  },
  {
    name: "eSign",
    url: "https://esign.clikkle.com/",
    logo: "https://cdn.clikkle.com/images/e-sign/logo/2025/clikkle%20esign.png",
  },
  {
    name: "Files",
    url: "https://files.clikkle.com/",
    logo: "https://cdn.clikkle.com/images/files/logo/2025/clikkle%20files.png",
  },
  {
    name: "HR",
    url: "https://hr.clikkle.com/",
    logo: "https://cdn.clikkle.com/images/hr/logo/2025/clikkle%20hr.png",
  },
  {
    name: "Projects",
    url: "https://projects.clikkle.com/",
    logo: "https://cdn.clikkle.com/images/projects/logo/2025/clikkle%20projects.png",
  },
  {
    name: "Calendar",
    url: "https://calendar.clikkle.com/",
    logo: "https://cdn.clikkle.com/images/calendar/logo/2025/Clikkle%20Calendar.png",
  },
  {
    name: "Crew",
    url: "https://crew.clikkle.com/",
    logo: "https://cdn.clikkle.com/images/crew/logo/2025/Clikkle%20Crew.png",
  },
  {
    name: "CRM",
    url: "https://crm.clikkle.com/",
    logo: "https://cdn.clikkle.com/images/crm/2025/clikkle%20crm.png",
  },
  {
    name: "Creator AI",
    url: "https://creator.clikkle.com/",
    logo: "https://cdn.clikkle.com/images/creator/logo/2025/Clikkle%20Creator.png",
  },
];

const drawerWidth = 240;
const appsWidth = 48;
const miniDrawerWidth = 85;

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
  backgroundColor: theme.palette.background.default,
  borderRight: "none",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  backgroundColor: theme.palette.background.default,
  overflowX: "hidden",
  width: `calc(${theme.spacing(8)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(12)} + 1px)`,
  },
  borderRight: "none",
});

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

export default function Navbar(props) {
  const navigate = useNavigate();
  const location = useLocation();
  const { children } = props;
  const [mobileOpen, setMobileOpen] = useState(false);
  const [sidebarApps, setSidebarApps] = useState(clikkleApps);
  const [isOrderChanged, setIsOrderChanged] = useState(false);
  const [editable, setEditable] = useState(false);
  const [user, setUser] = useState(null);
  const [collapseDrawer, setCollapseDrawer] = useState(false);
  const [drawerHover, setDrawerHover] = useState(false);
  const [menuHover, setMenuHover] = useState(false);
  const [pathname, setPathname] = useState(window.location.pathname);
  const requiredPath = pathname?.split("/").pop();
  const hasMultipleSlashes = (pathname?.match(/\//g) || []).length > 1;
  const [themeToggle, setThemeToggle] = useState("dark");
  const { toggleTheme, mode } = useTheme();

  const [anchorElSettings, setAnchorElSettings] = useState(null);
  const [isAdminSettingsOpen, setIsAdminSettingsOpen] = useState(false);

  const handleSettingsMenuOpen = (event) => {
    setAnchorElSettings(event.currentTarget);
  };

  const handleSettingsMenuClose = () => {
    setAnchorElSettings(null);
  };

  const handleThemeToggle = () => {
    window.location.reload();
    toggleTheme();
    window.location.reload();
    handleSettingsMenuClose();
  };

  const handleAdminSettingsOpen = () => {
    navigate("/manage-organization");
    handleSettingsMenuClose();
  };

  useEffect(() => {
    setPathname(location.pathname);
  }, [location.pathname]);

  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const { showError, showResponse } = useMessage();
  const platformUser = JSON.parse(localStorage.getItem("user"));
  const matches = useMediaQuery("(min-width:1024px)", { noSsr: true });
  const themee = useTheme();
  const theme = useMuiTheme();
  const {
    anchorEl: anchorElProfile,
    openMenu: openProfileMenu,
    closeMenu: closeProfileMenu,
  } = useMenu();

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const handleDrawerOpen = () => {
    setCollapseDrawer(!collapseDrawer);
  };
  const handleSetting = () => {
    navigate("/settings");
  };
  const onDragEnd = (result) => {
    const { source, destination } = result;
    if (!destination) return;
    if (
      source.droppableId === destination.droppableId &&
      source.index === destination.index
    )
      return;
    setIsOrderChanged(true);
    const draggingJob = sidebarApps[source.index];
    sidebarApps.splice(source.index, 1);
    sidebarApps.splice(destination.index, 0, draggingJob);
    setSidebarApps([...sidebarApps]);
  };


  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname, location.hash]);



  useEffect(() => {
    const setVh = () => {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty("--vh", `${vh}px`);
    };
    setVh();
    window.addEventListener("resize", setVh);
    return () => window.removeEventListener("resize", setVh);
  }, []);
  const SideBarLinkButton = ({ menus }) => {
    return (
      <>
        {menus.map((link, index) => (
          <div key={index}>
            <NavLink
              to={link.to}
              style={{ textDecoration: "none", color: "inherit" }}
            >
              {({ isActive }) => (
                <>
                  <ListItemButton
                    selected={isActive}
                    onClick={() => {
                      setCollapseDrawer(false);
                      setDrawerHover(false);
                    }}
                  >
                    <ListItemIcon>{link.icon}</ListItemIcon>
                    <ListItemText primary={link.label} />
                  </ListItemButton>

                </>
              )}
            </NavLink>
          </div>
        ))}
      </>
    );
  };

  const drawer = (
    <Box
      minHeight="100dvh"
      color="text.secondary"
      display="flex"
      flexDirection="column"
      className="w-full gap-4 p-3 items-center"
    >
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        className="gap-2 justify-center items-center"
      >
        <div
          className="relative cursor-pointer"
          onMouseOver={() => setMenuHover(true)}
          onMouseLeave={() => setMenuHover(false)}
        >
          <img
            src={`${process.env.REACT_APP_CDN_SERVER}/images/campaigns/logo/2025/clikkle%20campaigns.png`}
            alt={process.env.REACT_APP_NAME}
            style={{ height: "40px" }}
            onClick={handleDrawerToggle}
          />
        </div>
        <h1 className="font-semibold">{process.env.REACT_APP_NAME}</h1>
      </Box>
      <Divider variant="middle" sx={{ margin: 0, padding: 0, width: "100%" }} />
      <Box
        className="w-full"
        sx={{ overflowY: "auto", height: "calc(100dvh - 90px)", flexGrow: 1 }}
      >
        <List className="w-full">
          <GradientButton />
          <br />
          <SideBarLinkButton menus={userMenuItems} />
        </List>
      </Box>
    </Box>
  );

  const [visibleCount, setVisibleCount] = useState(9);
  const [anchorElMenu, setAnchorElMenu] = useState(null);
  const menuRef = useRef(null);
  const [trialEndOpen, setTrialEndOpen] = useState(false);

  const handleMoreClick = (event) => {
    setAnchorElMenu(event.currentTarget);
  };
  const handleCloseSideMenu = () => {
    setAnchorElMenu(null);
  };

  useEffect(() => {
    const updateVisibleCount = () => {
      if (menuRef.current) {
        const height = menuRef.current.clientHeight;
        const iconHeight = 60;
        const count = Math.floor(height / iconHeight);
        setVisibleCount(
          count >= userMenuItems.length ? userMenuItems.length : count
        );
      }
    };
    updateVisibleCount();
    window.addEventListener("resize", updateVisibleCount);
    return () => window.removeEventListener("resize", updateVisibleCount);
  }, [userMenuItems.length]);

  const miniDrawer = (
    <Box
      color="text.secondary"
      display="flex"
      flexDirection="column"
      className="h-full justify-between gap-6 items-center p-3 overflow-auto no-scrollbar"
    >
      <Box display="flex" alignItems="center" justifyContent="center">
        <div
          className="relative cursor-pointer"
          onMouseOver={() => setMenuHover(true)}
          onMouseLeave={() => setMenuHover(false)}
        >
          <div onClick={() => navigate("/")}>
            <img
              src={`${process.env.REACT_APP_CDN_SERVER}/images/campaigns/logo/2025/clikkle%20campaigns.png`}
              alt={process.env.REACT_APP_NAME}
              style={{ height: "35px" }}
            />
          </div>
        </div>
      </Box>
      <div
        className="h-full w-full flex flex-col gap-3 items-center justify-start"
        ref={menuRef}
      >

        <List sx={{ px: 1 }}>
          {userMenuItems.map((link) => {
            const isActive =
              location.pathname === link.to ||
              (link.subTabs &&
                link.subTabs.some((sub) =>
                  location.pathname?.startsWith(sub.to)
                ));

            return (
              <NavLink
                to={link.to}
                key={link.label}
                style={{ textDecoration: "none", color: "inherit" }}
              >
                <ListItem
                  sx={{
                    width: "100%",
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    mb: 0,
                    px: 0
                  }}
                >
                  <ListItemButton
                    selected={isActive}
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRadius: "12px",
                      width: "40px",
                      height: "40px",
                      minHeight: "40px",
                      p: 0,
                      backgroundColor: isActive ? (themee.mode === 'dark' ? "rgba(0, 128, 255, 0.1)" : "primary.100") : (themee.mode === 'dark' ? "rgba(255, 255, 255, 0.05)" : "transparent"),
                      color: isActive ? "primary.main" : "text.secondary",
                      "&:hover": {
                        backgroundColor: isActive ? (themee.mode === 'dark' ? "rgba(0, 128, 255, 0.2)" : "primary.200") : (themee.mode === 'dark' ? "rgba(255, 255, 255, 0.1)" : "action.hover"),
                      },
                      "&.Mui-selected": {
                        backgroundColor: themee.mode === 'dark' ? "rgba(0, 128, 255, 0.15)" : "primary.100",
                        color: "primary.main",
                        "&:hover": {
                          backgroundColor: themee.mode === 'dark' ? "rgba(0, 128, 255, 0.25)" : "primary.200",
                        }
                      }
                    }}
                  >
                    <ListItemIcon
                      sx={{
                        color: "inherit",
                        minWidth: "unset",
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        "& svg": {
                          fontSize: "22px"
                        }
                      }}
                    >
                      {link.icon}
                    </ListItemIcon>
                  </ListItemButton>

                  <ListItemText
                    primary={link.label}
                    primaryTypographyProps={{
                      fontSize: "11px",
                      fontWeight: isActive ? 600 : 500,
                      textAlign: "center",
                    }}
                    sx={{
                      mt: 0.5,
                      m: 0,
                      color: isActive ? "primary.main" : "text.secondary",
                      width: "100%",
                      display: 'block',
                      '& .MuiTypography-root': {
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis'
                      }
                    }}
                  />
                </ListItem>
              </NavLink>
            );
          })}
        </List>

        {visibleCount < userMenuItems.length && (
          <>
            <div
              onClick={handleMoreClick}
              className="w-full flex flex-col gap-1 justify-center items-center cursor-pointer"
            >
              <div
                style={{
                  backgroundColor:
                    themee.mode === "dark" ? "#181818" : "#F3F3F3",
                }}
                className="p-1 rounded-lg"
              >
                <MoreHorizIcon />
              </div>
              <h1 className="text-[10px]">More</h1>
            </div>
            <Menu
              className="left-10"
              anchorEl={anchorElMenu}
              open={Boolean(anchorElMenu)}
              onClose={handleCloseSideMenu}
            >
              {userMenuItems
                .filter((link) => link !== false)
                .slice(visibleCount)
                .map((link, index) => (
                  <MenuItem
                    key={index}
                    onClick={() => {
                      navigate(link.to);
                    }}
                  >
                    <div className="flex items-center gap-2">
                      <img src={link.icon} alt="" />

                      <span>{link.label}</span>
                    </div>
                  </MenuItem>
                ))}
            </Menu>
          </>
        )}
      </div>
    </Box>
  );

  const [leftMenuOpen, setLeftMenuOpen] = useState(false);
  const [openPlusIcon, setOpenPlusIcon] = useState(false);
  const [openActionModal, setOpenActionModal] = useState(false);
  const [previewItems, setPreviewItems] = useState([]);
  const dropdownRef = useRef(null);

  const handleClickOutside = (e) => {
    if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
      setOpenPlusIcon(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <Box
      sx={{
        bgcolor: "background.default",
        px: { xs: 0.5, xm: 0 },
        height: "100dvh",
        position: "relative",
      }}
    >
      <AppBar
        elevation={0}
        component={Box}
        position="sticky"
        sx={{
          width: {
            xs: "100%",
            xm:
              collapseDrawer && !drawerHover
                ? `calc(100% - ${drawerWidth}px)`
                : `calc(100% - ${miniDrawerWidth}px)`,
          },
          ml: {
            xm:
              collapseDrawer && !drawerHover
                ? `${drawerWidth}px`
                : `${miniDrawerWidth}px`,
          },
          backgroundColor: "background.default",
          borderBottom: "1px solid custom.border",
          color: "text.primary",
          transition: "ease-in-out 225ms, background-color 0s",
        }}
      >
        <Toolbar
          sx={{
            flexDirection: "column",
            justifyContent: "center",
            position: "relative",
            padding: 0,
            "&": {
              minHeight: "55px",
              px: 0,
              py: 0,
            },
          }}
        >
          <div
            style={{ borderBottom: { xs: "1px solid #1F1F1F", md: "none" } }}
            className="w-full flex gap-3 justify-between items-center p-2 sm:p-2 md:p-2 lg:p-0"
          >
            <div className="md:hidden">
              <VscMenu
                className="text-2xl mx-4"
                onClick={matches ? handleDrawerOpen : handleDrawerToggle}
              />
            </div>
            <span className="sm:block hidden">
              <TopNavigation />
            </span>

            <div className="w-full md:hidden flex flex-row gap-1 justify-between items-center rounded-[20px] h-[40px]">
              <SearchBar />
            </div>
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="flex-end"
              spacing={0}
              sx={{ display: { xs: "none", md: "block" } }}
            >
              <div className="w-fit hidden md:flex flex-row gap-3 justify-center items-center px-1 text-nowrap">
                {isSearchOpen && <SearchBar />}

                <GradientButton />
                <div className="relative inline-block">
                  <button
                    className="p-1 bg-[#0080FF14] bg-opacity-25 rounded-lg"
                    title="Get Started"
                    onClick={() => navigate("/")}
                  >
                    <BsPlusLg size={"20px"} color="#0080FF" />
                  </button>
                  {openPlusIcon && (
                    <div
                      ref={dropdownRef}
                      className="absolute right-0 z-50 mt-2 w-60 rounded-lg shadow-lg"
                      style={{
                        backgroundColor:
                          themee.mode === "dark" ? "#171717" : "#fff",
                      }}
                    >
                      <div className="flex justify-between items-center px-4 py-2 border-b">
                        <h3 className="font-medium text-sm">Quick Actions</h3>
                        <IconButton
                          onClick={() => setOpenActionModal(true)}
                          sx={{ bgColor: "transparent" }}
                        >
                          <FiSettings
                            className="cursor-pointer text-[#0080ff]"
                            size={16}
                          />
                        </IconButton>
                      </div>
                      <div className="p-2">
                        <input
                          type="text"
                          placeholder="Search"
                          className="w-full px-3 py-1 text-sm border rounded-md focus:outline-none focus:ring bg-transparent"
                        />
                      </div>
                      <div className="max-h-48 overflow-y-auto">
                        {previewItems?.map((item, index) => (
                          <div
                            key={index}
                            className="px-4 py-2 text-sm cursor-pointer"
                            onClick={() => {
                              setOpenPlusIcon(false);
                            }}
                          >
                            {item}
                          </div>
                        ))}
                      </div>
                    </div>
                  )}

                </div>
                <IconButton
                  title="Search"
                  onClick={() => setIsSearchOpen(!isSearchOpen)}
                >
                  <IoIosSearch />
                </IconButton>
                <IconButton title="chat clikkle" href={"https://chat.clikkle.com"}>
                  <PiChatTeardropText />
                </IconButton>
                <IconButton title="Video Call" href={"https://crew.clikkle.com"}>
                  <IoVideocamOutline />
                </IconButton>
                <IconButton
                  onClick={handleSettingsMenuOpen}
                >
                  <IoSettingsOutline
                    size={"20px"}
                  />
                </IconButton>

                <Menu
                  anchorEl={anchorElSettings}
                  open={Boolean(anchorElSettings)}
                  onClose={handleSettingsMenuClose}
                >
                  <MenuItem onClick={handleThemeToggle}>
                    <ListItemIcon>
                      {mode === "dark" ? (
                        <LightMode fontSize="small" />
                      ) : (
                        <DarkMode fontSize="small" />
                      )}
                    </ListItemIcon>
                    Appearance
                  </MenuItem>
                  <MenuItem onClick={handleAdminSettingsOpen}>
                    <ListItemIcon>
                      <AdminPanelSettings fontSize="small" />
                    </ListItemIcon>
                    Organization Settings
                  </MenuItem>
                </Menu>

                <AdminSettingsModal
                  open={isAdminSettingsOpen}
                  onClose={() => setIsAdminSettingsOpen(false)}
                />
                <Notification />

                <IconButton
                  onClick={openProfileMenu}
                  sx={{
                    width: "45px",
                    height: "45px",
                    padding: 0,
                    borderWidth: "2px",
                    borderStyle: "solid",
                    borderColor: "#3b84d9",
                    borderRadius: "50%", // makes it round
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {platformUser.profilePicture ? (
                    <img
                      src={platformUser.profilePicture}
                      alt="Profile"
                      style={{
                        width: "100%",
                        height: "100%",
                        borderRadius: "50%",
                        objectFit: "cover",
                      }}
                    />
                  ) : (
                    <Typography
                      variant="subtitle1"
                      fontWeight={500}
                      fontSize={14}
                      sx={{
                        color: "#3b84d9",
                      }}
                    >
                      {platformUser?.firstName && platformUser?.lastName
                        ? platformUser.firstName.charAt(0).toUpperCase() +
                        platformUser.lastName.charAt(0).toUpperCase()
                        : "?"}
                    </Typography>
                  )}
                </IconButton>

                <ProfileMenuModal
                  anchorElProfile={anchorElProfile}
                  closeProfileMenu={closeProfileMenu}
                />
              </div>
            </Stack>
            <div className="flex md:hidden">
              <IconButton
                onClick={openProfileMenu}
                sx={{
                  width: "45px",
                  height: "45px",
                  padding: 0,
                  borderWidth: "2px",
                  borderStyle: "solid",
                  borderColor: "#3b84d9",
                  borderRadius: "50%", // makes it round
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {platformUser.profilePicture ? (
                  <img
                    src={platformUser.profilePicture}
                    alt="Profile"
                    style={{
                      width: "100%",
                      height: "100%",
                      borderRadius: "50%",
                      objectFit: "cover",
                    }}
                  />
                ) : (
                  <Typography
                    variant="subtitle1"
                    fontWeight={500}
                    fontSize={14}
                    sx={{
                      color: "#3b84d9",
                    }}
                  >
                    {platformUser?.firstName && platformUser?.lastName
                      ? platformUser.firstName.charAt(0).toUpperCase() +
                      platformUser.lastName.charAt(0).toUpperCase()
                      : "?"}
                  </Typography>
                )}
              </IconButton>
            </div>
          </div>
        </Toolbar>

        <Box
          sx={{
            width: appsWidth,
            display: { xs: "none", xm: "block" },
            backgroundColor: "background.default",
            zIndex: "1200",
            position: "absolute",
            right: 0,
            top: 65,
            height: "80vh",
          }}
          className="mt-1"
        >
          <Stack
            direction="column"
            justifyContent={leftMenuOpen ? "start" : "end"}
            alignItems="center"
            spacing={1}
            px={0.8}
            height={"100%"}
            overflowY="auto"
          >
            {leftMenuOpen && (
              <>
                <DragDropContext onDragEnd={onDragEnd}>
                  <Droppable droppableId="apps" isDropDisabled={!editable}>
                    {(provided) => (
                      <div ref={provided.innerRef} {...provided.droppableProps}>
                        {sidebarApps.map((app, i) => (
                          <Draggable
                            key={i}
                            draggableId={app.name}
                            index={i}
                            isDragDisabled={!editable}
                          >
                            {(provided) => (
                              <div
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                              >
                                <ActionIcon
                                  title={editable ? "" : app.name}
                                  href={app.url}
                                  src={app.logo}
                                  key={app.order}
                                  sx={{ mt: 0.8, width: "35px" }}
                                />
                              </div>
                            )}
                          </Draggable>
                        ))}
                        {provided.placeholder}
                      </div>
                    )}
                  </Droppable>
                </DragDropContext>
                <Divider variant="middle" sx={{ my: 2, width: "80%" }} />
                {editable ? (
                  <ActionIcon
                    title="Save"
                    icon={<DoneIcon className="w-5" />}
                    onClick={() => {
                      setEditable(false);
                      // if (isOrderChanged) saveOrder();
                    }}
                  />
                ) : (
                  <ActionIcon
                    title="Edit"
                    icon={<EditIcon className="w-5" />}
                    onClick={() => setEditable(true)}
                  />
                )}
              </>
            )}
            <Box className="h-[80vh] flex justify-end items-end">
              {leftMenuOpen ? (
                <div
                  style={{
                    padding: "7px",
                    borderTop: "1px solid #1e2734",
                    borderLeft: "1px solid #1e2734",
                    borderBottom: "1px solid #1e2734",
                    cursor: "pointer",
                    borderTopLeftRadius: "15px",
                    borderBottomLeftRadius: "15px",
                    marginLeft: "15px",
                  }}
                  onClick={() => setLeftMenuOpen(!leftMenuOpen)}
                  className="h-fit w-fit"
                >
                  <IoIosArrowForward />
                </div>
              ) : (
                <div
                  style={{
                    padding: "7px",
                    borderTop: "1px solid #1e2734",
                    borderLeft: "1px solid #1e2734",
                    borderBottom: "1px solid #1e2734",
                    marginLeft: "10px",
                    cursor: "pointer",
                    borderTopLeftRadius: "15px",
                    borderBottomLeftRadius: "15px",
                  }}
                  className="h-fit w-fit"
                  onClick={() => setLeftMenuOpen(!leftMenuOpen)}
                >
                  <IoIosArrowBack />
                </div>
              )}
            </Box>
          </Stack>
        </Box>
      </AppBar>

      <span className="block sm:hidden">
        <TopNavigation />
      </span>
      <Box
        component="nav"
        sx={{
          width: { xm: drawerWidth },
          flexShrink: { sm: 0 },
          bgcolor: "custom.menu",
        }}
      >
        <MuiDrawer
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true,
          }}
          sx={{
            display: { xs: "block", xm: "none" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
              bgcolor: "custom.menu",
            },
          }}
        >
          {drawer}
        </MuiDrawer>
        <Drawer
          variant="permanent"
          open={collapseDrawer}
          hover={drawerHover}
          sx={{
            display: { xs: "none", xm: "block" },
            p: 0,
            "& .MuiDrawer-paper": {
              boxShadow: drawerHover
                ? "rgba(149, 157, 165, 0.2) 0px 8px 24px"
                : "none",
            },
          }}
        >
          {collapseDrawer ? drawer : miniDrawer}
        </Drawer>
      </Box>
      <Box
        component="main"
        sx={{
          width: {
            xs: "100%",
            xm:
              collapseDrawer && !drawerHover
                ? `calc(100% - ${drawerWidth + appsWidth}px)`
                : `calc(100% - ${appsWidth + miniDrawerWidth}px)`,
          },
          ml: {
            xm:
              collapseDrawer && !drawerHover
                ? `${drawerWidth}px`
                : `${miniDrawerWidth}px`,
          },
          mt: 1,
          mb: { xs: 7, sm: 0 },
          height: {
            xs: "calc(var(--vh, 1vh) * 100 - 125px)",
            sm: "calc(var(--vh, 1vh) * 100 - 75px)",
          },
          backgroundColor: "background.paper",
          overflowY: "auto",
          borderRadius: "12px",
          p: "20px"

        }}
      >
        {children}
      </Box>
    </Box>
  );
}
